module.exports = __webpack_public_path__ + "img/M4_JKKP_04.d77db03c.png";